import { Component, Input } from '@angular/core';
import { ProductPresentation } from '@models/product';
import { FaqComponent } from 'app/shared/components/faq/faq.component';

@Component({
    selector: 'app-faq-handy',
    templateUrl: './faq-handy.component.html',
    styleUrls: ['./faq-handy.component.scss'],
    imports: [FaqComponent],
})
export class FaqHandyComponent {
    @Input()
    public productPresentation: ProductPresentation;
}
